// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles-module--switch--2-43E","active":"styles-module--active--248J9","description":"styles-module--description--3LERp"};